import classNames from 'classnames';
import { memo } from 'react';

import { type CustomFieldTableHeaderProps } from '~/components/TableView/CustomFieldTableHeader/types';
import { TableCell } from '~/components/TableView/TableCell';

export const CustomFieldTableHeader = memo(({ customFieldName, resizeHandle, style }: CustomFieldTableHeaderProps) => {
  return (
    <TableCell
      style={style}
      data-testid={customFieldName}
      data-disableselect="true"
      className={classNames('p-1.5 px-2 ads:text-secondary text-gray-11', !!resizeHandle && 'relative')}
    >
      {customFieldName}
      {resizeHandle}
    </TableCell>
  );
});
CustomFieldTableHeader.displayName = 'CustomFieldTableHeader';
